import orderChallengeModules from "@/common/utils/orderChallengeModules";

export default {
    state: {
        isLoadingChallenges: false,
        isLoadingChallenge: false,
        isFinishChallenge: false,
        isFinishingCurrentChallenge: false,
        accessedChallengesList: [],
        current: null,
        showModalChallenge: false,
    },
    actions: {
        getChallenge({ commit, state }, { id }) {
            if (!state.current) {
                state.isLoadingChallenge = true;
            }
            return axios.get(`/api/v1/student/challenge/${id}`)
                .then(response => {
                    const { data : {data : challenge }} = response
                    commit('SET_CHALLENGE', challenge);
                    return response;
                })
                .finally(() => state.isLoadingChallenge = false);
        },
        startChallenge({ commit, state, rootState }, { id }) {
            state.isLoadingChallenge = true;
            return axios.post("/api/v1/student/challenge/start", { id })
            .then(response => {
                const  { data : { data : challenge }} = response
                challenge.is_running = true
                commit('SET_CHALLENGE', challenge);
                commit('SET_CYCLES', rootState.cycle.list.map(cycle => {
                    if (cycle.id === challenge.cycle_config_id) {
                        cycle.challenge = challenge;
                    }
                    return cycle;
                }));
                return response;
            })
            .finally(() => state.isLoadingChallenge = false);
        },
        finishChallenge({ commit, state }, { id, data }) {
            state.isFinishChallenge = true;
            return axios.post("/api/v1/student/challenge/finish", {
                ...data,
                id,
            })
                .then(response => {
                    commit('SET_CHALLENGE', response.data.data);
                    return response;
                })
                .finally(() => state.isFinishChallenge = false);
        },
        createChallenge({ commit, state, rootState }, { cycle_config_id }) {
            state.isLoadingChallenge = true;
            return axios.post("/api/v1/student/challenge/create", { cycle_config_id })
                .then(response => {
                    commit('SET_CHALLENGE', response.data.data);
                    commit('SET_CYCLES', rootState.cycle.list.map(cycle => {
                        if (cycle.id === response.data.data.cycle_config_id) {
                            cycle.challenge = response.data.data;
                        }
                        return cycle;
                    }));
                    return response;
                })
                .finally(() => state.isLoadingChallenge = false);
        },
        answerChallenge({ commit, state, getters , rootState,  }, { id, data }) {
            data.challenge_id = id;
            return axios.post(`/api/v1/student/challenge/answer`, data)
                .then(response => {

                    commit('SET_CHALLENGE', {
                        ...getters.challenge,
                        questions: getters.challenge.questions.map(q => {
                            if(q.id == data.question_id){
                                q.user_answer =  data.user_answer
                            }
                            return q
                        })
                    });
                    commit('SET_CYCLES', rootState.cycle.list.map(cycle => {
                        cycle.challenge = response.data.data.id ? response.data.data : cycle.challenge;
                        return cycle;
                    }));
                    return response;
                })
        },
        accessChallenge({dispatch, commit},{id, cycle_config_id }){
          dispatch( id ? "getChallenge" : "createChallenge", ({id, cycle_config_id })).then(() => commit("SHOW_MODAL_CHALLENGE"))
        }
    },
    mutations: {
        SET_CHALLENGE(state, challenge) {

            state.current = challenge ? {
                ...challenge,
            } :  challenge;

            if(challenge){
              if (!state.accessedChallengesList.length) {
                state.accessedChallengesList = [challenge]
              } else if (!state.accessedChallengesList.filter(c => c.id === challenge.id).length) {
                  state.accessedChallengesList = [...state.accessedChallengesList, challenge]
              } else {
                  state.accessedChallengesList = state.accessedChallengesList.map(c => {
                      if (c.id === challenge.id) {
                          c = challenge;
                      }
                      return c
                  })
              }
            }
        },
        SHOW_MODAL_CHALLENGE(state, payload = true) {
            state.showModalChallenge = payload
        },
        SET_IS_FINISH_CURRENT_CHALLENGE(state, payload = true) {
            state.isFinishingCurrentChallenge = payload
        }
    },
    getters: {
        challenge : state  => state.current ? ({
          ...state.current,
          questions: state.current.questions.map((q, index)=> ({...q, key:index}))
        }) : null,
        challengeModules: (state, getters) =>  getters.challenge ? orderChallengeModules(getters.challenge.questions) : [],
        currentChallengeQuestions: (state, getters) =>  getters.challenge ? getters.challenge.questions : [],
        isFinishChallenge: state=> state.isFinishChallenge
    }
}
